module.exports = __webpack_public_path__ + "static/media/1007026.cc18b57e.jpg";